import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { FadeEffect } from "./components/FadeEffect";

export const ErrorAlert = () => {
  const {
    formState: { errors },
  } = useFormContext();
  const shouldShow = Boolean(errors?.root?.message);
  const [errorMessage, setErrorMessage] = useState(errors?.root?.message);

  useEffect(() => {
    if (shouldShow) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setErrorMessage(errors?.root?.message);
    }
  }, [shouldShow]);

  return (
    <FadeEffect shouldShow={shouldShow}>
      <div
        className="bg-red-50 border border-feedback-error px-6 py-5 rounded-lg text-red-900"
        data-testid="upsell-error-alert"
        dangerouslySetInnerHTML={{ __html: errorMessage ?? "" }}
      />
    </FadeEffect>
  );
};
